import {Component, inject, Input} from '@angular/core';
import {BaseRecordTableItemComponent} from '../../base-record-table-item/base-record-table-item.component';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {customDateProvider} from "../../../../../locale/providers/custom-date.provider";
import {switchDateFormats} from "./configs/date-record-table-item-config";
import {ErrorService} from "../../../../../services/error.service";
import {UtilityService} from "../../../../../services/utility.service";

@Component({
  selector: 'app-date-record-table-item',
  standalone: false,
  templateUrl: './date-record-table-item.component.html',
  styleUrls: [
    '../../base-record-table-item-styles.scss',
    './date-record-table-item.component.scss'
  ],
  providers: [ ...customDateProvider ]
})
export class DateRecordTableItemComponent extends BaseRecordTableItemComponent {
  @Input({ transform: switchDateFormats }) override value!: string;
  @Input() isFilter: boolean = false;

  private errorService: ErrorService = inject(ErrorService);
  private utilityService: UtilityService = inject(UtilityService);

  public defaultValue: string = this.value;

  public handleDateInputChange(date: MatDatepickerInputEvent<any, any>): void {
    const formattedDate = date.value ? this.utilityService.formatDateToRussianStyle(date.value) : null;
    super.handleValueChange(formattedDate);
  }

  public onInputChange(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    const parts = input.split('.');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);

    if (month > 12 || day > 31) {
      (event.target as HTMLInputElement).value = '';
      this.errorService.showErrorMessage('Некорректная дата');
    }
  }

  public clearDatePicker(): void {
    this.value = this.defaultValue;
    super.handleValueChange('');
  }
}
